import { Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: "root"
})

export class SigaSeuPlanoService {

  constructor(private http: HttpClient) {

  }

  public ListarHistorico(numItens: number, numPagina: number): Observable<any> {

    return this.http
      .get(`${environment.apiURL}/Aberto/SigaSeuPlano/ListarHistorico`, { params: { numItens: numItens, numPagina: numPagina } } as any);
  }

  public ListarArquivos(codArqGrupo: number): Observable<any> {

    return this.http
                .get(`${environment.apiURL}/Aberto/SigaSeuPlano/ListarArquivos`, {params: {codArqGrupo: codArqGrupo}} as any);
  }

  public DownloadArquivo(hashCodArquivo: any){

    return this.http
                .get(`${environment.apiURL}/Aberto/SigaSeuPlano/DownloadArquivo?hashCodArquivo=${hashCodArquivo}`, {responseType: "blob"})
  }
}
